import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosSharedModule } from '../shared/module'
import { IcosLoadingDirective } from './loading.directive'

@NgModule({
  declarations: [IcosLoadingDirective],
  exports: [IcosLoadingDirective],
  imports: [CommonModule, IcosSharedModule],
  entryComponents: [],
})
export class IcosLoadingModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosLoadingModule, providers: []}
  }
}
